import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bannerAddCrumb } from 'utils/breadcrumbInfo';
import { deleteBannerById, getAllBanners } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import GenericTable from 'screens/components/advanced/GenericTable';
import WithRouter from 'custom/withRouter';
import { DialogInput } from 'screens/components/advanced';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import { DialogActions, Typography } from '@mui/material';
class BannerListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerList: [],
      openDeleteDialog: false,
      selectedBannerId: null,
      linkURL: '/ecommerce/bannerList/add',
    };

    this.getBanners = this.getBanners.bind(this);
    this.editBanner = this.editBanner.bind(this);
  }

  componentDidMount() {
    this.getBanners();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.bannerDataSuccess !== prevProps.bannerDataSuccess &&
      this.props.bannerDataSuccess
    ) {
      this.setState({
        bannerList: this.props.bannerDataSuccess?.map((item) => {
          const branchName = item.isGlobal
            ? ''
            : this.props.branches?.find((b) => b.id === item.branchId)?.name ||
              '-';

          return {
            BannerName: item.bannerName || '-',
            BannerAlt: item.bannerAlt || '-',
            BannerTypeName: item.bannerTypeName,
            BranchName: branchName,
            IsGlobal: item.isGlobal ? (
              <p className="statusIconGreen m-0">Yes</p>
            ) : (
              <p className="statusIconRed m-0">No</p>
            ),
            DisplayOrder: item.displayOrder || '-',
            IsActive: item.isActive ? (
              <p className="statusIconGreen m-0">Active</p>
            ) : (
              <p className="statusIconRed m-0">Inactive</p>
            ),
            Buttons: (
              <div>
                <Button
                  type="IconEditButton"
                  onTouchTap={() => this.editBanner(item.id)}
                />
                <Button
                  style={{ minWidth: `25px`, height: `25px`, color: 'red' }}
                  type="IconDeleteButton"
                  onTouchTap={() => this.removeBanner(item.id)}
                />
              </div>
            ),
          };
        }),
      });
    }
  }

  getBanners() {
    this.props.getAllBanners({
      branchId: this.props.branchId,
    });
  }

  editBanner(id) {
    this.props.navigate(`/ecommerce/bannerList/edit/${id}`);
  }

  handleConfirmDelete = () => {
    const { selectedBannerId } = this.state;
    if (!selectedBannerId) return;

    this.props.deleteBanner(selectedBannerId);
    this.setState({ openDeleteDialog: false, selectedBannerId: null });

    setTimeout(() => {
      this.getBanners();
    }, 300);
  };

  removeBanner = (bannerId) => {
    this.setState({
      openDeleteDialog: true,
      selectedBannerId: bannerId,
    });
  };

  handleCancelDelete = () => {
    this.setState({ openDeleteDialog: false });
  };
  render() {
    const { linkURL, bannerList } = this.state;
    const columns = [
      { key: 'BannerName', label: 'Name' },
      { key: 'BannerAlt', label: 'Alt Text' },
      { key: 'BannerTypeName', label: 'Type' },
      { key: 'BranchName', label: 'Branch Name' },
      { key: 'IsGlobal', label: 'Global Banner' },
      { key: 'DisplayOrder', label: 'Display Order' },
      { key: 'IsActive', label: 'Status' },
      { key: 'Buttons', label: 'Actions' },
    ];

    return (
      <>
        <DialogInput
          title={
            <DialogHeaderWithClose
              text="Delete Banner"
              classicClass="posDialogClassic"
              handleClose={this.handleCancelDelete}
            />
          }
          className="no_btns_dialog"
          modal={true}
          open={this.state.openDeleteDialog}
          autoScrollBodyContent={true}
        >
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to delete this banner?
          </Typography>

          <DialogActions>
            <Button onTouchTap={()=>this.handleCancelDelete()}>Cancel</Button>
            <Button onTouchTap={()=> this.handleConfirmDelete()} variant="contained">
              Delete
            </Button>
          </DialogActions>
        </DialogInput>
        <Grid headerContent={bannerAddCrumb}>
          <PageHeaderWithButton title="Banner List">
            <Button
              type="AddButton"
              mini
              className="bg-light-green"
              label="ADD NEW BANNER"
              onTouchTap={() => this.props.navigate(linkURL)}
            />
          </PageHeaderWithButton>

          <div className="list-table-last list-no-p">
            <CardSimple className="pa-1">
              <GenericTable
                className="table_center tableHeaderwhiteColorFont"
                tableBodyClassName="productgroup-table"
                multiSelectable={false}
                enableSelectAll={false}
                selectable={false}
                stripedRows={true}
                columns={columns}
                rows={bannerList}
              />
            </CardSimple>
          </div>
        </Grid>
      </>
    );
  }
}

function mapStateToProps(state) {
  let branches = state.common.userBranches || [];
  let brachOptions = [];
  branches.map((item) => {
    brachOptions.push({
      text: item.name,
      value: item.id.toString(),
    });
  });
  return {
    branches: branches,
    branchId: state.common.branchId,
    bannerDataSuccess: state.entity.bannerDataSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllBanners: (model) => dispatch(getAllBanners(model)),
    showError: (message) => dispatch(showError(message)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    deleteBanner: (bannerId) => dispatch(deleteBannerById(bannerId)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithRouter(BannerListPage));
